import * as React from "react";
import { useIntl } from "react-intl";
import { v4 } from "uuid";

import { DesktopContainer, InfoIconContainer, InfoIconIcon, InfoIconText, MobileContainer, Root } from "./InfoIcon.sc";
import { InfoIconPortal } from "./InfoIconPortal";

interface InfoIconProps {
    infoText?: React.ReactNode;
    alignment?: "left" | "right" | "center";
    color?: "white" | "porschebankBlue";
}

const InfoIcon: React.FunctionComponent<InfoIconProps> = ({ infoText, color = "porschebankBlue", alignment = "left" }) => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [isDesktopOpen, setIsDesktopOpen] = React.useState<boolean>(false);
    const infoIconTextId = React.useMemo(() => v4(), []);

    return (
        <Root>
            <DesktopContainer>
                <InfoIconContainer
                    tabIndex={0}
                    onFocus={() => setIsDesktopOpen(true)}
                    onKeyDown={(e) => e.key === "Escape" && setIsDesktopOpen(false)}
                    onBlur={() => setIsDesktopOpen(false)}
                    onMouseLeave={() => setIsDesktopOpen(false)}
                    aria-label={intl.formatMessage({ id: "infoIcon.openTooltip", defaultMessage: "Info anzeigen" })}
                    aria-describedby={infoIconTextId}
                >
                    <InfoIconIcon color={color}>i</InfoIconIcon>
                </InfoIconContainer>
                <InfoIconText alignment={alignment} isOpen={isDesktopOpen} role="tooltip" id={infoIconTextId}>
                    {infoText}
                </InfoIconText>
            </DesktopContainer>
            <MobileContainer>
                <InfoIconContainer
                    onClick={(e) => {
                        e.preventDefault();
                        setIsOpen(true);
                    }}
                >
                    <InfoIconIcon color={color}>i</InfoIconIcon>
                </InfoIconContainer>
                <InfoIconPortal infoText={infoText} isOpen={isOpen} onClose={() => setIsOpen(false)} />
            </MobileContainer>
        </Root>
    );
};

export default InfoIcon;
